// extracted by mini-css-extract-plugin
var _1 = "TabPanel_hidden__9f491";
var _2 = "TabPanel_root__ac584";
export { _1 as "hidden", _2 as "root" }
